import React, { FC } from 'react';
import styles from './TimerMessage.module.scss';

const TimerMessage: FC = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export default TimerMessage;
